import { mapState, mapGetters } from 'vuex'
import Tabs from '@/shared/components/Tabs'

export default {
  components: { Tabs },
  computed: {
    ...mapGetters('landing', ['active']),
    ...mapState('landing', ['currentView']),
    options() {
      return this.active.options
    },
  },
}
